import {
    Alert,
    Col, Row,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

export interface NoRequestsProps {
    serviceType?: string;
    serviceName?: string;
    serviceNameLinkTitle?: string;
    serviceNameLinkUrl?: string;
}

const NoRequests = (props: NoRequestsProps) => {
    const {
        serviceType = 'Testing and Calibration', // default props
        serviceName = 'request', // default props
        serviceNameLinkTitle = 'request', // default props
        serviceNameLinkUrl = '/request-for-quote-create', // default props
    } = props;

    return (
        <Row className='mb-3'>
            <Col>
                <Alert
                    variant='info'
                    data-testid='info-summary'
                    role='status'
                    aria-live='polite'
                    className='d-flex mb-4'
                >
                    <div className='d-flex justify-content-center justify-content-md-start mb-3 mb-md-0'>
                        <div className='bgCircle mb-3 me-3'>
                            <i className='icon-info' aria-hidden='true' />
                        </div>
                    </div>
                    <div>
                        <p className='mb-2'>
                            <strong>
                                {`You currently have no ${serviceType} ${serviceName}s, please `}
                            </strong>
                        </p>
                        <ul>
                            <li>
                                {'Check the other tabs above for in progress '}
                                {serviceType}
                                {' '}
                                {serviceName}
                                s or
                            </li>
                            <li>Adjust your search filter options or</li>
                            <li>
                                {'Create a '}
                                <Link to={serviceNameLinkUrl}>{serviceNameLinkTitle}</Link>
                            </li>
                        </ul>
                    </div>
                </Alert>
            </Col>
        </Row>
    );
};

export default NoRequests;
